import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';
import { rateWatch, rateUpdatedAt } from './data';
export function RateWatch() {
  return <section className="bg-navy-600 rounded-xl p-5 text-white" aria-label="Rate watch" data-id="element-734">
      <div className="flex items-center justify-between mb-4" data-id="element-735">
        <h3 className="text-base font-serif font-bold" data-id="element-736">Rate Watch</h3>
        <span className="text-[0.65rem] text-navy-200 uppercase tracking-wide" data-id="element-737">
          {rateUpdatedAt}
        </span>
      </div>

      <ul className="divide-y divide-white/10" data-id="element-738">
        {rateWatch.map(r => {
        const up = r.change > 0;
        const down = r.change < 0;
        return <li key={r.product} className="flex items-center justify-between py-2.5" data-id="element-739">
              <div data-id="element-740">
                <p className="text-sm font-semibold" data-id="element-741">{r.product}</p>
                <p className="text-[0.7rem] text-navy-200" data-id="element-742">APR {r.apr}</p>
              </div>
              <div className="text-right" data-id="element-743">
                <p className="text-base font-bold text-gold-400 leading-none" data-id="element-744">
                  {r.rate}
                </p>
                <span className={`inline-flex items-center gap-0.5 text-[0.7rem] font-semibold mt-0.5 ${down ? 'text-sage' : up ? 'text-blush' : 'text-navy-200'}`} data-id="element-745">
                  {down ? <ArrowDownRight className="w-3 h-3" data-id="element-746" /> : up ? <ArrowUpRight className="w-3 h-3" data-id="element-747" /> : <Minus className="w-3 h-3" data-id="element-748" />}
                  {r.change === 0 ? 'flat' : `${Math.abs(r.change)} bps`}
                </span>
              </div>
            </li>;
      })}
      </ul>

      <p className="text-[0.65rem] text-navy-300 mt-3 leading-snug" data-id="element-749">
        Internal pricing reference only — not a consumer rate quote.
      </p>
    </section>;
}